import { lazy } from "react"
import { FaProductHunt } from "react-icons/fa"
import { SiTemporal } from "react-icons/si"
import { app, condition, group } from "statics/route_data"

const general = lazy(() => import('./general'))
const items = lazy(() => import('./items'))
const itemGroups = lazy(() => import('./itemGroups'))
const countries = lazy(() => import('./countries'))
const warehouses = lazy(() => import('./warehouses'))
const binLocations = lazy(() => import('./binLocations'))
const batches = lazy(() => import('./batches'))
const serials = lazy(() => import('./serials'))
const purchaseOrders = lazy(() => import('./purchaseOrders'))
const salesOrders = lazy(() => import('./salesOrders'))

let g: any

export default () => {
  if (!g) {
    g = group('sag', "T.menu.standalone.group", SiTemporal, [
      app(
        'sag0',
        '/stand_alone/masterdata/general',
        'T.menu.standalone.masterdata.general',
        FaProductHunt,
        general,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag1',
        '/stand_alone/masterdata/items',
        'T.menu.standalone.masterdata.items',
        FaProductHunt,
        items,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag1.1',
        '/stand_alone/masterdata/itemGroups',
        'T.menu.standalone.masterdata.itemGroups',
        FaProductHunt,
        itemGroups,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag2',
        '/stand_alone/masterdata/countries',
        'T.menu.standalone.masterdata.countries',
        FaProductHunt,
        countries,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag3',
        '/stand_alone/masterdata/warehouses',
        'T.menu.standalone.masterdata.warehouses',
        FaProductHunt,
        warehouses,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag4',
        '/stand_alone/masterdata/binLocations',
        'T.menu.standalone.masterdata.binLocations',
        FaProductHunt,
        binLocations,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag5',
        '/stand_alone/masterdata/batches',
        'T.menu.standalone.masterdata.batches',
        FaProductHunt,
        batches,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag6',
        '/stand_alone/masterdata/serials',
        'T.menu.standalone.masterdata.serials',
        FaProductHunt,
        serials,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag7',
        '/stand_alone/masterdata/purchaseOrders',
        'T.menu.standalone.masterdata.purchaseOrders',
        FaProductHunt,
        purchaseOrders,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
      app(
        'sag8',
        '/stand_alone/masterdata/salesOrders',
        'T.menu.standalone.masterdata.salesOrders',
        FaProductHunt,
        salesOrders,
        {},
        condition('admin', [], [], [], (user, config, deviceConfig) => config.erpType === 'STAND_ALONE')
      ),
    ])
  }
  return g
}
